var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSidebarCollapse = function SvgSidebarCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.083A.917.917 0 004.085 5v10c0 .506.41.916.917.916h1.75V4.083H5zm3.25 0v11.833H15c.507 0 .917-.41.917-.916V5a.917.917 0 00-.916-.917H8.25zM5 17.416h10A2.417 2.417 0 0017.418 15V5a2.417 2.417 0 00-2.416-2.417H5A2.417 2.417 0 002.584 5v10a2.417 2.417 0 002.417 2.416zm7.198-9.613a.75.75 0 00-1.061 1.06L12.273 10l-1.136 1.136a.75.75 0 001.06 1.06l1.667-1.666a.75.75 0 000-1.06l-1.666-1.667z",
    fill: "#48525C"
  })));
};
export default SvgSidebarCollapse;